var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"data"},[_vm._v("\n        "+_vm._s(_vm.data)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }